import React from 'react'
import {Policies} from 'components/Accommodation/Policies'
import {
  isAnySubSectionAvailable,
  isCheckInCheckOutAvailable
} from 'components/Accommodation/Policies/utils'
import {WrapperWithPadding} from 'components/Accommodation/WrapperWithPadding'

import {Divider} from '@daedalus/atlas/Divider'
import {useGetHotelQuery} from '@daedalus/core/src/sapi/services/searchApi'
import {ContentHotel} from '@findhotel/sapi'

export const ConditionalPolicies = ({hotel}: {hotel: ContentHotel}) => {
  const hotelId = hotel?.objectID
  const {data: contentHotel, error} = useGetHotelQuery(
    {
      hotelId
    },
    {
      skip: !hotelId
    }
  )
  const shouldRenderPolicies = !(
    error ||
    (contentHotel &&
      !isCheckInCheckOutAvailable(contentHotel) &&
      !isAnySubSectionAvailable(contentHotel))
  )

  if (!shouldRenderPolicies) return null

  return (
    <>
      <Divider sideMargin="s500" />
      <WrapperWithPadding>
        <Policies hotelId={hotelId} />
      </WrapperWithPadding>
    </>
  )
}
